import React, { useContext, useEffect, useState } from "react";
import Utils from "../../utils";
import AuthUtil from "../../utils/auth";
import { UserContext } from "../../context";
import CustomDrawer from "../../../src/components/drawer";
import CustomModal from "../../../src/components/modal";
import {
  SettingOutlined,
  MailOutlined,
  FundOutlined,
  PhoneOutlined,
  LockOutlined,
  LogoutOutlined,
  CloseOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { Avatar } from "antd";
import styles from "./layout-header.module.css";
import GenericPopover from "../pop-over";
import { TUser } from "../../types/config";
import SettingsForm from "./settings-form";
import ActionCard from "../actionCard/actionCard";
import SendOTP from "../../pages/auth/reset-password";

type Options = {
  value: string;
  label: string;
};

export default function UserProfile() {
  const context: any = useContext(UserContext);
  const [userDetails, setUserDetails] = useState<TUser>(context.user);
  const [moduleId, setModuleId] = useState("");
  const navigate = useNavigate(); // Replaces Next.js router
  const [options, setOptions] = useState<Options[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  useEffect(() => {
    setUserDetails(context.user);
    fetchListOfModelData();
    setModuleId(context.ActiveModuleId);
  }, [context.user]);

  function signOut() {
    AuthUtil.logout();
    Utils.redirectUrl(`/login`);
  }

  const handleClick = () => {
    navigate("/dashboard/user-profile/form"); // Replaces router.push
  };

  const handlePasswordClick = () => {
    setIsPasswordModalOpen(true); // Open Change Password modal
  };

  const handleModalOk = () => {
    setIsModalOpen(false); // Close modal
  };

  const handleModalCancel = () => {
    setIsModalOpen(false); // Close modal
    setIsPasswordModalOpen(false);
  };

  const fetchListOfModelData = async () => {};

  const handleSettingsClick = () => {
    setIsModalOpen(true); // Open modal on Settings click
  };

  const UserProfileContent: React.FC<{ onCloseDrawer: () => void }> = ({
    onCloseDrawer,
  }) => (
    <>
      <CloseOutlined
        style={{
          cursor: "pointer",
          padding: "1rem",
          fontSize: "1rem",
          fontFamily: "Montserrat-SemiBold",
          color: "white",
        }}
        onClick={onCloseDrawer}
      />
      <div className={styles.userBox}>
        <div className={styles.pencil}>
          <Avatar
            size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
            src="https://api.dicebear.com/7.x/miniavs/svg?seed=1"
          >
            {userDetails?.displayName || ""}
          </Avatar>
          <span className={styles.userName}>
            {userDetails?.displayName
              ? userDetails?.displayName
              : userDetails?.emailId}
          </span>
        </div>
        <div className={styles.userProfile}>
          <div
            className={styles.profileWrapper}
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleSettingsClick();
              onCloseDrawer();
            }}
          >
            <SettingOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%" }}>Settings</span>
          </div>
          <div className={styles.profileWrapper}>
            <MailOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%", wordBreak: "break-all", lineHeight:"15px" }}>
              {userDetails?.emailId}
            </span>
          </div>
          <div className={styles.profileWrapper}>
            <PhoneOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%", lineHeight:"15px" }}>{userDetails?.mobileNo}</span>
          </div>
          <div className={styles.profileWrapper}>
            <FundOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%", wordBreak: "break-all", lineHeight:"15px" }}>
              {userDetails?.orgName}
            </span>
          </div>
          <div className={styles.profileWrapper}>
            <IdcardOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%", wordBreak: "break-all", lineHeight:"15px" }}>
              {userDetails?.roles?.[0]?.name}
            </span>
          </div>
          <div
            className={styles.profileWrapper}
            onClick={() => {
              handlePasswordClick();
              onCloseDrawer();
            }}
            style={{ cursor: "pointer" }}
          >
            <LockOutlined style={{ fontSize: "1.2rem" }} />
            <span style={{ width: "90%" }}>Change Password</span>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <GenericPopover
        placement="bottomLeft"
        content={
          <div className="standardActionBox">
            {" "}
            <CustomDrawer
              key={`user-profile-drawer`}
              trigger={
                <ActionCard text="Settings">
                  <SettingOutlined style={{ fontSize: "1.3rem" }} />
                </ActionCard>
              }
              component={UserProfileContent}
              componentProps={{}}
              title="User Profile"
              width={300}
            />
            <ActionCard text="Sign Out" onClick={signOut}>
              <LogoutOutlined style={{ fontSize: "1.2rem" }} />
            </ActionCard>
          </div>
        }
        icon={
          <FontAwesomeIcon
            icon={faUserCircle}
            style={{ color: "#a89c9c" }}
            size="2xl"
          />
        }
      />
      <CustomModal
        title="Change Password"
        isOpen={isPasswordModalOpen}
        onOk={() => {}}
        onCancel={handleModalCancel}
        hideOkButton={true}
        hideCancelButton={true}
        okText=""
        cancelText=""
        width="31%"
      >
        <SendOTP handleModalCancel={handleModalCancel} />
      </CustomModal>
      <CustomModal
        title="Settings"
        isOpen={isModalOpen}
        onOk={() => handleModalOk()}
        onCancel={() => handleModalCancel()}
        hideOkButton={true}
        hideCancelButton={true}
      >
        <SettingsForm onClose={handleModalCancel}></SettingsForm>
      </CustomModal>
    </>
  );
}
